// Доступ к Героям по фракциям. Сгенерированные heroes-*.js — это просто массивы;
// эта обёртка маршрутизирует выбор по факции.

import { heroes as heroesDeus } from './heroes-deus.js';
import { heroes as heroesSyntetics } from './heroes-syntetics.js';
import { heroes as heroesGlobal } from './heroes-global.js';
import { heroes as heroesLivlife } from './heroes-livlife.js';
import { heroes as heroesNeutral } from './heroes-neutral.js';

// В.1.a-fix3: фильтр Героев Глобала снят — все 5 Героев выбираемы. Их
// активки и пассивки на этом этапе игнорируются (warning при выставлении).
// Реальная реализация — В.1.h.
const ALL_HEROES = {
  deus: heroesDeus,
  syntetics: heroesSyntetics,
  global: heroesGlobal,
  livlife: heroesLivlife,
  neutral: heroesNeutral
};

export function getHeroes(factionId) {
  return ALL_HEROES[factionId] || [];
}

// Возвращает первого Героя фракции (по сортировке id).
// На А.1 этого достаточно — позже сделаем выбор Героя в UI.
export function defaultHero(factionId) {
  const list = getHeroes(factionId);
  if (list.length === 0) throw new Error(`У фракции "${factionId}" нет Героев`);
  return list[0];
}

// Принудительный Герой Игрока для плейтеста +Влияния (А.4.4.1).
// Никоси даёт самые наглядные срабатывания триггеров. Бот по-прежнему берёт defaultHero.
export const FORCED_PLAYER_HERO =
  heroesDeus.find(h => h.id === 'deus_nikosi') || null;

// Короткие имена Героев — для лога. На плашке Героя в UI показывается полное имя_ru.
// Захардкожено по id, чтобы не плодить колонки в xlsx.
const SHORT_NAMES = {
  deus_tanaki: 'Танаки',
  deus_kirosa: 'Кироса',
  deus_nikosi: 'Никоси',
  deus_sina: 'Сина',
  neutral_lider_ulicy: 'Лидер'
};

export function shortHeroName(card) {
  if (!card) return '';
  if (SHORT_NAMES[card.id]) return SHORT_NAMES[card.id];
  // Фолбэк: берём последнее слово из name_ru.
  const parts = String(card.name_ru || '').trim().split(/\s+/);
  return parts[parts.length - 1] || card.name_ru || card.id;
}
